import { waitForElm } from '../utils/global-functions';

function addComma() {
  const main = document.querySelector('#MainContent');
  const context = main.dataset.template;
  const reviewElm = document.getElementsByClassName('yotpo-bottom-line-basic-text')[0];
  const reviewText = reviewElm.innerHTML;

  if (context == 'page') {
    const reviewsWidget = document.querySelector('#pageReviews');
    const reviewNumber = parseInt(reviewText.substring(9).substring(0, reviewText.substring(9).indexOf(' '))).toLocaleString('en-US');
    const reviewWithComma = `Based on ${reviewNumber} reviews`;
    reviewElm.innerText = reviewWithComma;
    reviewsWidget.classList.add('active');
  } else {
    const reviewsWidget = document.querySelector('#ReviewsWidget');
    const reviewCount = parseInt(reviewText.substring(0, reviewText.indexOf(' '))).toLocaleString('en-US');
    const reviewWithComma = `${reviewCount} reviews`;
    reviewElm.innerText = reviewWithComma;
    reviewsWidget.classList.add('active');
  }
}

function showEmptyState() {
  const reviewsWidget = document.querySelector('#ReviewsWidget');
  reviewsWidget.classList.add('active');
}

waitForElm('.yotpo-bottom-line-basic-text').then((elm) => {
  addComma();
});

waitForElm('.yotpo-empty-state').then((elm) => {
  showEmptyState();
});
